var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandPatternCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "590px",
    height: "295px",
    viewBox: "0 0 590 295",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-1.1-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L-1-1_Dashboard_log_in",
    transform: "translate(-850.000000, -605.000000)",
    stroke: "#FFF308",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(837.500000, 605.500000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 394,
    cy: 394,
    r: 386.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 394,
    cy: 394,
    rx: 357,
    ry: 356.704688
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 394,
    cy: 394,
    rx: 326.827338,
    ry: 327.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandPatternCircles);
export default __webpack_public_path__ + "static/media/brand-pattern-circles.d154606ff3cc61067f734c41601cf4d7.svg";
export { ForwardRef as ReactComponent };